import Dark from './Dark';

function App() {
  return (
    <div className="App">
      <Dark />
    </div>
  );
}

export default App;
